// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fund-performance {
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  background-color: var(--surface-primary);
}

/* Header / legend row */
.fund-performance__header {
  display: flex;
  align-items: center;
  width: 100%;
  height: 33px;
  padding: 3px 0;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border-primary);
}

.fund-performance__title {
  flex: 1 0 0;
  min-width: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  color: var(--text-primary);
}

.fund-performance__legend {
  display: flex;
  flex-shrink: 0;
  gap: 16px;
  align-items: center;
}

.fund-performance__legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-weight: 400;
  font-size: 12px;
  line-height: normal;
  color: var(--text-primary);
  white-space: nowrap;
}

.fund-performance__swatch {
  width: 8px;
  height: 8px;
  flex-shrink: 0;
}

.fund-performance__swatch--fund {
  background-color: var(--chart-primary);
}

.fund-performance__swatch--benchmark {
  background-color: var(--chart-septenary);
}

/* Data rows */
.fund-performance__row {
  display: flex;
  gap: 16px;
  box-sizing: border-box;
  align-items: center;
  width: 100%;
  height: 32px;
  padding: 2px 0;
  border-bottom: 1px solid var(--border-tertiary);
}

.fund-performance__period {
  flex-shrink: 0;
  width: 60px;
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-secondary);
}

.fund-performance__value {
  flex: 1 0 0;
  min-width: 0;
  text-align: right;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}

.fund-performance__value--up {
  color: var(--text-up-color);
}

.fund-performance__value--down {
  color: var(--text-down-color);
}

.fund-performance__value--unchg {
  color: var(--text-unchg-color);
}

/* Diverging bar chart */
.fund-performance__bar {
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  flex-direction: column;
  gap: 1px;
  justify-content: center;
}

.fund-performance__bar-row {
  display: flex;
  height: 6px;
  width: 100%;
}

.fund-performance__bar-half {
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  height: 100%;
}

.fund-performance__bar-half--neg {
  justify-content: flex-end;
}

.fund-performance__bar-half--pos {
  justify-content: flex-start;
}

.fund-performance__bar-fill {
  height: 100%;
}

.fund-performance__bar-fill--fund {
  background-color: var(--chart-primary);
}

.fund-performance__bar-fill--benchmark {
  background-color: var(--chart-septenary);
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/FundSummaryWidget/components/FundPerformance/FundPerformance.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,wCAAwC;AAC1C;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,cAAc;AACd;EACE,aAAa;EACb,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".fund-performance {\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  background-color: var(--surface-primary);\n}\n\n/* Header / legend row */\n.fund-performance__header {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 33px;\n  padding: 3px 0;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.fund-performance__title {\n  flex: 1 0 0;\n  min-width: 0;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: normal;\n  color: var(--text-primary);\n}\n\n.fund-performance__legend {\n  display: flex;\n  flex-shrink: 0;\n  gap: 16px;\n  align-items: center;\n}\n\n.fund-performance__legend-item {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: normal;\n  color: var(--text-primary);\n  white-space: nowrap;\n}\n\n.fund-performance__swatch {\n  width: 8px;\n  height: 8px;\n  flex-shrink: 0;\n}\n\n.fund-performance__swatch--fund {\n  background-color: var(--chart-primary);\n}\n\n.fund-performance__swatch--benchmark {\n  background-color: var(--chart-septenary);\n}\n\n/* Data rows */\n.fund-performance__row {\n  display: flex;\n  gap: 16px;\n  box-sizing: border-box;\n  align-items: center;\n  width: 100%;\n  height: 32px;\n  padding: 2px 0;\n  border-bottom: 1px solid var(--border-tertiary);\n}\n\n.fund-performance__period {\n  flex-shrink: 0;\n  width: 60px;\n  text-align: center;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-secondary);\n}\n\n.fund-performance__value {\n  flex: 1 0 0;\n  min-width: 0;\n  text-align: right;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.fund-performance__value--up {\n  color: var(--text-up-color);\n}\n\n.fund-performance__value--down {\n  color: var(--text-down-color);\n}\n\n.fund-performance__value--unchg {\n  color: var(--text-unchg-color);\n}\n\n/* Diverging bar chart */\n.fund-performance__bar {\n  display: flex;\n  flex: 1 0 0;\n  min-width: 0;\n  flex-direction: column;\n  gap: 1px;\n  justify-content: center;\n}\n\n.fund-performance__bar-row {\n  display: flex;\n  height: 6px;\n  width: 100%;\n}\n\n.fund-performance__bar-half {\n  display: flex;\n  flex: 1 0 0;\n  min-width: 0;\n  height: 100%;\n}\n\n.fund-performance__bar-half--neg {\n  justify-content: flex-end;\n}\n\n.fund-performance__bar-half--pos {\n  justify-content: flex-start;\n}\n\n.fund-performance__bar-fill {\n  height: 100%;\n}\n\n.fund-performance__bar-fill--fund {\n  background-color: var(--chart-primary);\n}\n\n.fund-performance__bar-fill--benchmark {\n  background-color: var(--chart-septenary);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
